import highcharts from 'highcharts'
import Scroll from '../javascripts/scroll'

document.addEventListener('DOMContentLoaded', () => {
  const createChart = element => {
    const name = JSON.parse(element.dataset.name)
    const value = JSON.parse(element.dataset.value)
    const isLabelInside = element.dataset.labelInside
    const options = {
      chart: {
        renderTo: element,
        type: 'bar',
        height: element.clientHeight,
        spacing: [0, 1, 0, 1],
        style: {
          fontFamily: `'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', Osaka, 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS P Gothic', Verdana, sans-serif`,
        },
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            color: '#333',
          },
          align: isLabelInside ? 'left' : 'right',
          x: isLabelInside ? 0 : -5,
          y: isLabelInside ? -16 : undefined,
        },
        tickWidth: 0,
      },
      yAxis: {
        title: {
          text: '',
        },
        labels: {
          format: '{value}%',
          style: {
            color: '#333',
          },
        },
        min: 0,
        tickAmount: 5,
        gridLineWidth: 1,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          pointWidth: 20,
          dataLabels: {
            enabled: true,
            format: '{point.y:.0f}%',
            style: {
              color: '#333',
              fontWeight: 'normal',
            },
          },
        },
      },
      tooltip: {
        enabled: false,
      },
      series: [
        {
          name: 'Key',
          color: '#00a394',
          states: {
            hover: {
              enabled: false,
            },
          },
          data: [
            {
              name: name[0],
              y: parseInt(value[0], 10),
            },
            {
              name: name[1],
              y: parseInt(value[1], 10),
            },
            {
              name: name[2],
              y: parseInt(value[2], 10),
            },
            {
              name: name[3],
              y: parseInt(value[3], 10),
            },
            {
              name: name[4],
              y: parseInt(value[4], 10),
            },
            {
              name: name[5],
              y: parseInt(value[5], 10),
            },
          ],
        },
      ],
    }
    new highcharts.Chart(options)
  }

  const chartElement = document.getElementsByClassName('js-company-bar')
  if (chartElement.length) {
    ;[].forEach.call(chartElement, element => {
      Scroll.scrollInViewElement(element, createChart)
    })
  }
})
